<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <!-- <img src="@/assets/img/logo_white.png" alt="logo图"> -->
    </div>
    <p class="title">广州市悦途科技服务有限公司</p>
    <p class="address_tel_fax">
      <span>地址：广州市增城区荔城街增城大道28号之二402房</span>
      <span>Tel：13535043619</span>
    </p>
    <p class="email_wx">
      <span>邮箱：626685645@qq.com22</span>
    </p>
    <p class="copy">Copyright &copy; 2021 - {{ new Date().getFullYear() }} 广州市悦途科技服务有限公司</p>
    <p class="icp">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
        粤ICP备2023140842号-3
      </a>
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
.icp {
  color: #d3d3d3;
  font-size: 12px;
  margin-bottom: 10px;
}
.icp a {
  color: #d3d3d3;
  text-decoration: none;
}
.icp a:hover {
  color: #fff;
  text-decoration: underline;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue